import React, { Fragment, useState, useEffect } from 'react';
import { Card, CardHeader, CardBody, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Form, Row, Col } from 'reactstrap';
import SweetAlert from 'sweetalert2';
import DataTable from 'react-data-table-component';
import { H3, Btn, Breadcrumbs, H4 } from '../../../AbstractElements';
import { Link, useNavigate } from 'react-router-dom';
import { getClientUrlDataToken, postClientUrlWithToken } from '../../../Utils/restUtils';
import { Add, Users, UsersList, Search, Filter } from '../../../Constant';
import { useForm } from 'react-hook-form';
import { Deleteagent, viewAgent } from '../../../CommonUrl';
import { useSelector } from 'react-redux';
import { conditionalRow } from '../../Common/Rowstyle/Rowstyle';
import Transparentspinner from '../../Common/Loader/Transparentspinner';
import { toast } from 'react-toastify';
import Popup from '../../Common/Popup/popup';
import AgentForm from './AgentForm';

const AgentTab = ({ register, control, errors }) => {
    const navigate = useNavigate();
    const authState = useSelector((state) => state.auth);
    const toggleStyle = { padding: '10px 20px', opacity: '0.8', fontSize: '14px' }
    const changepwdtitile = <span className='billerqColor bolder '><h3>Change Password</h3></span>;
    const [agentLists, setAgentList] = useState([]);
    const [filters, setFilters] = useState({
        search: '',
    });
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [userValue, setUserValue] = useState('');
    const [modal, setModal] = useState(false);
    const [sortConfig, setSortConfig] = useState({ column: '', order: '' });
    const style2 = { width: '100%', fontSize: 13, padding: 3, marginRight: '10px' };

    const AgentColumns = [
        {
            name: <H4>Sl</H4>,
            selector: row => row.Si,
            width: '75px',
        },
        {
            name: <H4>Name</H4>,
            id: 'name',
            selector: row => row.Name,
            sortable: true,
        },
        {
            name: <H4>Email</H4>,
            id: 'email',
            selector: row => row.Email,
            sortable: true,
        },
        {
            name: <H4>Roles</H4>,
            id: 'role',
            selector: row => row.Roles,
            sortable: true,
        },
        {
            name: <H4>Action</H4>,
            selector: row => row.action,
            sortable: true,
            center: true,
            width: '280px',
        },
    ];

    const handleSort = (column) => {
        let newOrder = 'asc';
        if (sortConfig.column === column.id) {
            newOrder = sortConfig.order === 'asc' ? 'desc' : 'asc';
        }
        setSortConfig({ column: column.id, order: newOrder });
        fetchAgent(currentPage, perPage, filters.search, column.id, newOrder);
    };

    const handleApiError = (status) => {
        if (status >= 400 && status <= 405) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (status >= 500 && status <= 505) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        } else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
        }
    };

    const handleModal = (id) => {
        setUserValue(id);
        setModal(!modal);
    };

    const fetchAgent = async (page, size = perPage, searchKey = '', sortBy = '', sortOrder = '') => {
        setLoading(true);
        const response = await getClientUrlDataToken(authState.apiUrl, viewAgent +
            `?page=${page}&page_length=${size}&search=${searchKey}&sort_by=${sortBy}&sort_order=${sortOrder}`);
        if (response.status === true) {
            setResetPaginationToggle(!resetPaginationToggle);
            const SerialNo = (page - 1) * size + 1;
            setAgentList(response.data.data.map((e, index) => {
                return {
                    Si: SerialNo + index,
                    Name: <span>{e.first_name} {e.last_name}</span>,
                    Email: e.email,
                    Roles: e.role_name,
                    id: e.id,
                    action:
                        <div>
                            <span>
                                <Btn attrBtn={{ style: style2, color: 'primary btn-xs', type: 'button', onClick: () => handleModal(e.id) }}>Update Reward Ratio</Btn>
                            </span>
                        </div >
                }
            }))
            setTotalRows(response.data.total);
        } else {
            handleApiError(response.status);
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchAgent(1);
    }, []);

    const handlePageChange = page => {
        fetchAgent(page, perPage, filters.search, sortConfig.column, sortConfig.order);
        setCurrentPage(page);
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        fetchAgent(page, newPerPage, filters.search, sortConfig.column, sortConfig.order);
        setPerPage(newPerPage);
    };

    return (
        <Fragment>
            {loading && <Transparentspinner />}
            <Card className='cardWidth'>
                <CardBody>
                    <div className="order-history table-responsive">
                        <DataTable
                            columns={AgentColumns}
                            data={agentLists}
                            onSort={handleSort} // Attach sorting handler here
                            sortServer // Enable server-side sorting
                            pagination
                            paginationServer
                            defaultSortAsc
                            paginationTotalRows={totalRows}
                            paginationDefaultPage={currentPage}
                            onChangeRowsPerPage={handlePerRowsChange}
                            conditionalRowStyles={conditionalRow}
                            onChangePage={handlePageChange}
                            fixedHeader
                        />
                    </div>
                </CardBody>
            </Card>
            <Popup isOpen={modal} title={'Reward Ratio'} toggler={handleModal}>
                <AgentForm userValue={userValue} handleModal={handleModal}/>
            </Popup>
        </Fragment>
    );
};

export default AgentTab;